"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBody = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const ModalBody = ({ open, onClose, accent, className, children, testing }) => {
    const [animateIn, setAnimateIn] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let timeout = null;
        if (open !== undefined) {
            // open is being passed through!
            if (open) {
                timeout = window.setTimeout(() => {
                    setAnimateIn(true);
                }, 10);
            }
            else {
                setAnimateIn(false);
            }
        }
        return () => {
            if (timeout) {
                window.clearTimeout(timeout);
            }
        };
    }, [open]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('relative h-fit w-full max-w-screen-lg overflow-y-auto rounded-lg bg-white px-8 py-6 shadow-lg transition-transform', animateIn ? 'translate-y-0' : '-translate-y-8', className), "aria-modal": "true" },
        accent && (react_1.default.createElement("div", { "data-testid": testing && 'accent', className: "absolute top-0 left-0 h-2 w-full bg-blood-orange-4" })),
        onClose && (react_1.default.createElement("button", { className: "absolute right-6 top-5 flex h-8 w-8 items-center justify-center rounded-full px-2 font-body text-3xl hover:bg-grey-2 focus:outline-none focus:ring focus:ring-blue-3", onClick: onClose }, "\u00D7")),
        children));
};
exports.ModalBody = ModalBody;
